// eslint-disable-next-line import/prefer-default-export
export enum PLANS {
	PLANS_LOAD_START = 'PLANS_LOAD_START',
	PLANS_LOAD_DONE = 'PLANS_LOAD_DONE',
	PLANS_LOAD_FAIL = 'PLANS_LOAD_FAIL'
}
